import { font, colors } from "@styles/cssinjs/helpers/variables";

/**
 * Price-card duration text, optionally with a "USD" label stacked above it
 * (shown to non-US visitors). Rendered INSIDE the `.plan-duration-wrap` span —
 * the parent adds the `has-currency-code` class when `show` is true, which
 * turns that span into the flex column this styles.
 *
 * Single source of truth for the USD label markup + styling; reused by
 * GetProFreePlanCards, PricingPlan and PremiumPlanComparision.
 *
 * @param {boolean} show Whether to render the USD label (from useShowCurrencyLabel).
 * @param {string} duration The duration text, e.g. "user / month".
 */
export default function CurrencyDuration({ show, duration }) {
  if (!show) return duration;
  return (
    <>
      <span className="plan-currency-code">USD</span>
      <span className="plan-duration-text">{duration}</span>
      <style jsx global>{`
        .plan-duration-wrap.has-currency-code {
          display: inline-flex;
          flex-direction: column;
          vertical-align: text-bottom;
        }
        .plan-currency-code {
          font-size: ${font.size.sm[2]} !important;
          font-weight: ${font.weight.bold};
          line-height: 1 !important;
          letter-spacing: 0.12px;
          text-transform: uppercase;
          color: ${colors.primitive.black[900]};
        }
        .plan-duration-text {
          line-height: 1.4 !important;
        }
      `}</style>
    </>
  );
}
